import React, { Component } from "react";
import {
  FaTwitter,
  FaInstagram,
  FaFacebookF,
  FaLinkedinIn,
} from "react-icons/fa";

const SocialShare = [
  { Social: <FaFacebookF />, link: "https://www.facebook.com/" },
  { Social: <FaLinkedinIn />, link: "https://www.linkedin.com/" },
  { Social: <FaInstagram />, link: "https://www.instagram.com/" },
  { Social: <FaTwitter />, link: "https://twitter.com/" },
];

class Footer extends Component {
  render() {
    const { onChildAction, isMobile } = this.props;
    return (
      <React.Fragment>
        <footer className="footer-area">
          <div className="footer-wrapper">
            <div className="row align-items-end row--0">
              <div className="col-lg-6">
                <div className="footer-left">
                  <div className="inner">
                    <span>Ready To Do This</span>
                    <h2>
                      Let's get <br /> to work
                    </h2>
                    {!isMobile ? (
                      <a
                        className="rn-button-style--2"
                        href="#"
                        onClick={onChildAction}
                      >
                        <span>Connect Now</span>
                      </a>
                    ) : (
                      <a className="rn-button-style--2" href="/connect">
                        <span>Connect Now</span>
                      </a>
                    )}
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="footer-right" data-black-overlay="6">
                  <div className="row">
                    {/* Start Single Widget  */}
                    <div className="col-lg-6 col-sm-6 col-12">
                      <div className="footer-link">
                        <h4>Quick Links</h4>
                        <ul className="ft-link">
                          <li>
                            <a href="/mortgage-calculator">
                              Mortgage Calculator
                            </a>
                          </li>
                          <li>
                            <a href="/refinance-calculator">
                              Refinance Calculator
                            </a>
                          </li>
                          <li>
                            <a href="/faqs">FAQS</a>
                          </li>
                          <li>
                            <a href="/blog">Our Latest Blogs</a>
                          </li>
                          <li>
                            <a href="/about">About us</a>
                          </li>
                        </ul>
                      </div>
                    </div>
                    {/* End Single Widget  */}
                    {/* Start Single Widget  */}
                    <div className="col-lg-6 col-sm-6 col-12 mt_mobile--30">
                      <div className="footer-link">
                        <h4>Say Hello</h4>
                        <ul className="ft-link">
                          <li>
                            <a href="mailto:support@example.com">
                              support@loandeer.com
                            </a>
                          </li>
                        </ul>

                        <div className="social-share-inner">
                          <ul className="social-share social-style--2 d-flex justify-content-start liststyle mt--15">
                            {SocialShare.map((val, i) => (
                              <li key={i}>
                                <a href={`${val.link}`}>{val.Social}</a>
                              </li>
                            ))}
                          </ul>
                        </div>
                      </div>
                    </div>
                    {/* End Single Widget  */}

                    <div className="col-lg-12">
                      <div className="copyright-text">
                        <p>
                          Copyright © 2024 LoanDeer LLC. All Rights Reserved.
                        </p>
                        <div>
                          <a href="/terms" className="pr-5">
                            Terms & Conditions
                          </a>
                          <a href="/privacypolicy">Privacy Policy</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </footer>
      </React.Fragment>
    );
  }
}
export default Footer;
